export const visit = (vm, at) => {
at({ "es": { "conversations-visitor-experience-components": { "stagedAttachment": { "uploadProgress": "{{uploadedBytes}} de {{totalBytes}}" }, "fileSizeLimit": "El archivo no puede ser m\xE1s grande que {{size}}" } } });
};